function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconAmenitiesYukataFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M11.997 2.369l-.469-.494-9.023 8.914c-.259.256-.446.56-.526.904-.082.35-.035.666.052.914a1.836 1.836 0 00.457.708l3.096 3.286.002.003.003.003.008.008.017.018a1.558 1.558 0 00.19.162c.114.085.29.194.517.268.235.076.53.116.858.044.301-.065.575-.212.816-.421V28.04c0 .394.094.756.288 1.065.192.306.445.503.677.626a2.022 2.022 0 00.859.232h2.086v-2h-1.91V11.66l-3.16 3.352-2.78-2.95L11.513 4.7l2.137 2.137 1.407-1.407-3.06-3.06z",
    fill: props.color
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.38 10.77l-6.908-6.998.005-.005-.744-.743-.647-.656-.005.004-.018-.019L14 9.416v20.549h8.475c.296 0 .584-.083.83-.256a1.4 1.4 0 00.455-.55 1.595 1.595 0 00.146-.57l.002-.025v-.025l.001-.02v-.015l-1-.001h1V16.685a1.989 1.989 0 00.625.358c.22.076.51.128.837.07a1.75 1.75 0 00.907-.469l.02-.02 3.124-3.314c.263-.257.451-.568.523-.924a1.62 1.62 0 00-.087-.923 1.914 1.914 0 00-.477-.693zm-1.532 1.294l-6.79-6.878L16 10.244v17.72h5.91V11.66l3.16 3.353 2.778-2.95zM11.905 21.08H9.567v-2h2.338v2z",
    fill: props.color
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.74 21.08H15v-2h7.74v2z",
    fill: props.color
  }));
}

export default SvgIconAmenitiesYukataFilled;